import React, { useContext, useEffect, useState } from 'react';
import {T} from '../../../utils/I18n/I18n';
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import Button from '../../UI/Button/Button';
import {useQuery, useMutation, useLazyQuery} from "@apollo/react-hooks";
import { EXPORT_STATUS } from "../PersonalAreaAddress/queriesAddress";
import {DATA_EXPORT,START_EXPORT} from "../PersonalAreaWishlist/wishlistQuery";

import './PersonalAreaPrivacySettings.scss';
import {usePopup} from "../../../context/PopupContext";


const PersonalAreaPrivacySettings = () => {
    const [status, setStatus] = useState("");
    const { t } = useTranslation();
    const { loading, error, data: exportStatus, refetch } = useQuery(EXPORT_STATUS, {
        fetchPolicy: "no-cache"
    })

    // DATA_EXPORT
    const [downloadFile] = useLazyQuery(DATA_EXPORT, {
        fetchPolicy: "no-cache",
        onCompleted: download
    })

    const [exportFile] = useMutation(START_EXPORT, {
        fetchPolicy: "no-cache"
    });

    const { showAddToCartPopupMessage } = usePopup();

    function download(data) {
        if(data.exportDownload && data.exportDownload.status) {
            const fileContents = data.exportDownload.file.content;
            const fileName = data.exportDownload.file.name;
            const element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;base64,' + fileContents);
            element.setAttribute('download', fileName);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
            showAddToCartPopupMessage(data.exportDownload.message, 'success', 4000);
        }

        if(data.exportDownload && !data.exportDownload.status) {
            showAddToCartPopupMessage(data.exportDownload.message, 'error', 4000);
        }
    }


    useEffect(() => {
        if(!error){
            if(!loading) {
                setStatus(exportStatus.exportStatus)
            }
        }else{
            console.log("Error occured", error)
        }
    }, [exportStatus])


    const buttonHandler = async () => {
        if(status === "notStarted") {
            await exportFile();
            refetch();
        }
        if(status === "isExported"){
            downloadFile();
        }
    }

    return (
        <div className="privacy-settings">
            <span className="privacy-settings__personal-area-title">{<T id="privacy.title"/>}</span>
            <p className="privacy-settings__header">{<T id="privacy.header"/>}</p>
            <p className="privacy-settings__info">
                {<>
                    <T id="privacy.info"/>
                    <Link to={`/kontakt-i-usluge/${t('user.conditions')}-poslovanja`} className="privacy-settings__condition"><T id="privacy.condition"/></Link>
                </>
                }
            </p>
            <p className="privacy-settings__header">{<T id="privacy.loadHeader"/>}</p>
            <div className="privacy-settings__button">
                {status === "notStarted" && <Button onClick={buttonHandler} type="submit" trait="profile-hover" text={<T id="privacy.submit"/>}/>}
                {status === "Exists" && <p className="privacy-settings__pending"><T id="privacy.pending"/></p>}
                {status === "isExported" && <Button onClick={buttonHandler} type="submit" trait="profile-hover" text={<T id="privacy.download"/>}/>}
            </div>
        </div>
    )
}

export default PersonalAreaPrivacySettings;